module.exports = __webpack_public_path__ + "static/media/arrowDownWhite.e86ab450.svg";